<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="color"
    d="M11.419 3.13A1 1 0 0 1 13 3.942v16.114a1 1 0 0 1-1.581.814L6 17H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3l5.419-3.87ZM17 12c0-1.542-.58-2.947-1.537-4.01l-.196-.208-.068-.076a1 1 0 0 1 1.415-1.4l.075.07.262.277A7.974 7.974 0 0 1 19 12a7.979 7.979 0 0 1-2.292 5.606 1.001 1.001 0 0 1-1.427-1.401A5.978 5.978 0 0 0 17 12Z"
  />
  <path
    [attr.fill]="color"
    d="M21 12A9.966 9.966 0 0 0 18.07 4.93a1 1 0 1 1 1.414-1.414A11.966 11.966 0 0 1 23 12c0 3.313-1.344 6.315-3.515 8.485a1 1 0 0 1-1.414-1.414A9.966 9.966 0 0 0 21 12.001Z"
  />
</svg>
